import { TooltipComponentOption } from "echarts";
import { round } from "lodash";

import { FormatCurrencyFunction, FormatCurrencyOptions } from "@/hooks/useConfig/types";
import { getMappedName } from "@/Utils/mapping-utils";

const getContribution = (value: number, total: number) => {
  if (!total) return "0%";
  return `${round((value / total) * 100, 2)}%`;
};

export const getTooltip = (
  totals: number[],
  formatCurrency: FormatCurrencyFunction,
  currencyFormatterOptions: FormatCurrencyOptions = {},
  mapDefaultNodeName: (name: string) => string
): TooltipComponentOption => ({
  trigger: "item",
  formatter: (params: any) => {
    const total = totals?.[params.dataIndex] ?? 0;
    return `
      <div style='border-left: 4px solid ${params.color}; padding: 16px; border-radius: 4px 0 0 4px;'>
        <div style="margin-bottom: 8px;">
          <span style="font-weight: 600; font-size: 16px;">${mapDefaultNodeName(params.name)}</span>
        </div>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px;">
          <div style="font-size: 14px; font-weight: 600;">${getMappedName(params.seriesName) ?? params.seriesName}:</div>
          <div>${formatCurrency(params.value, currencyFormatterOptions)}</div>
          <div style="font-size: 14px; font-weight: 600;">Total Shown:</div>
          <div>${formatCurrency(total, currencyFormatterOptions)}</div>
          <div style="font-size: 14px; font-weight: 600;">Contribution:</div>
          <div>${getContribution(params.value, total)}</div>
        </div>
      </div>
    `;
  },
});
